import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { ExternalProviderRepository } from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface UploadExternalProviderInvoiceCommand {
  file: File;
  externalProviderRepository: ExternalProviderRepository;
}

export const uploadExternalProviderInvoice = createApiThunk<string, UploadExternalProviderInvoiceCommand>(
  "externalProvider/uploadInvoice",
  async ({ file, externalProviderRepository }: UploadExternalProviderInvoiceCommand) => {
    return externalProviderRepository.uploadInvoice(file);
  },
);

export const resetUploadExternalProviderInvoice = createAction("externalProvider/resetUploadInvoice");
